export enum PhoneNumberType {
  Mobile = 'mobile',
  Landline = 'landline',
}

export const PhoneNumberTypeDescriptionMap = new Map([
  [PhoneNumberType.Mobile, 'Mobile'],
  [PhoneNumberType.Landline, 'Landline'],
]);
